<app-block-list
  [blockIdList]="body"
  class="flex flex-col min-h-screen pb-page-bottom"
></app-block-list>
